export const CODE_GARAGE = '/code-garage';
export const CODE_PLAYGROUND = '/code-playground';
export const CLASSROOMS = '/classrooms';